<span *ngIf="singleFlightSeats; else noSeats" class="comma-separated">
  <span *ngFor="let seat of singleFlightSeats" class="font-body-2 regular-type ps-xxsmall-b">
    {{ seat }}
  </span>
</span>
<span *ngFor="let flightSeats of flightsSeats; last as lastFlight" class="font-body-2 regular-type ps-xxsmall-b">
  {{ flightSeats.flight }}:
  <span class="comma-separated">
    <span *ngFor="let seat of flightSeats.seats" class="font-body-2 medium-type ps-xxsmall-b">
      {{ seat }}
    </span>
  </span>
  <span *ngIf="!lastFlight"> / </span>
</span>
<ng-template #noSeats>
  <div class="font-body-2 regular-type ps-xxsmall-b">
    {{ 'MMB.services.seats.noneIncluded' | finLocalization }}
  </div>
</ng-template>
